import React, { useCallback } from 'react';

import Button, { ButtonProps } from 'components/Button';
import Link from 'components/Link';

import { useDispatch } from 'react-redux';
import useTranslate from 'hooks/useTranslate';
import useWorkflow from 'hooks/useWorkflow';
import { resetApplication } from 'state/resetApplication';

const RestartButton: React.FC<ButtonProps> = props => {
  const dispatch = useDispatch();
  const t = useTranslate();
  const { restartPath } = useWorkflow();
  const onClick = useCallback(() => {
    dispatch(resetApplication());
  }, [dispatch]);
  const textToRender = props.children
    ? props.children
    : t('creditApplication.restartButton');

  return (
    <Button
      id="appRestart"
      variant="text"
      component={Link}
      to={restartPath}
      onClick={onClick}
    >
      {textToRender}
    </Button>
  );
};

export default RestartButton;
